import type { Client, RequestContext } from "../client";
import { ConfigurationRepository } from "../repositories/configurationRepository";
import type { LetsEncryptConfigurationResource } from "../resources";
export class LetsEncryptConfigurationRepository extends ConfigurationRepository<LetsEncryptConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("LetsEncryptConfiguration", client, requestContext);
    }
}
